import { ChangeDetectionStrategy, Component, input, model, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PrimeTemplate } from 'primeng/api';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { FileUploaderComponent } from '../../../../components/file-uploader/file-uploader.component';

@Component({
  selector: 'app-transcript-upload-dialog',
  templateUrl: './transcript-upload-dialog.component.html',
  styleUrl: './transcript-upload-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Dialog, PrimeTemplate, Button, FileUploaderComponent, TranslatePipe]
})
export class TranscriptUploadDialogComponent {
  visible = model(false);
  titleKey = input('ITP.selectTranscripts');
  upload = output<File[]>();

  stagedFiles = signal<File[]>([]);

  /**
   * Adds newly selected files to the staged list
   * @param files - Files chosen via drag/drop or browse
   */
  onFilesStaged(files: File[]): void {
    this.stagedFiles.update(current => [...current, ...files]);
  }

  /**
   * Removes a file from the staged list
   * @param index - Position of the file to remove
   */
  removeFile(index: number): void {
    this.stagedFiles.update(current => current.filter((_, i) => i !== index));
  }

  /**
   * Emits the staged files for upload and closes the dialog
   */
  onUpload(): void {
    this.upload.emit(this.stagedFiles());
    this.close();
  }

  /**
   * Clears staged files and closes the dialog
   */
  close(): void {
    this.stagedFiles.set([]);
    this.visible.set(false);
  }
}
